<template>
  <div class="cmp cmp-menu">
    <div class="menu_list">
      <p v-for="(v, i) in data" :class="{ bg: activeIndex === i }" :key="i" @click="menuItemClick(v, i)">
        <span v-if="v.type === 'EVALUATE'">
          {{ (v.evaluate || {}).type === "UNIT" ? "单元评价" : "任务评价" }}
        </span>
        <span v-else>
          {{ typeDict[v.type] }}
        </span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "cmp-menu",
  props: {
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    setActiveIndex: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  data() {
    return {
      activeIndex: 0,
      typeDict: {
        // SUBJECT_DISCUSSION: "主题讨论",
        EVALUATE: "单元评价",
        CLASSROOM_TEST: "课堂练习",
        CLASSROOM_QUESTION: "课堂问卷",
        GROUP_CHITCHAT: "组内聊天",
        CLASSROOM_JOB: "课堂作业",
      },
    };
  },
  watch: {
    setActiveIndex(newVal) {
      console.log(newVal, "99999999999");
      if (newVal > 0) this.activeIndex = newVal;
    },
  },
  computed: {
    sliderStyles() {
      let left = 0;
      if (this.data.length < 5) {
        left = `${this.activeIndex * 232}px`;
      } else {
        left = `${(this.activeIndex * 100) / this.data.length}%`;
      }
      return { left };
    },
    activeLabel() {
      let type = (this.data[this.activeIndex] || {}).type;
      return this.typeDict[type];
    },
  },

  methods: {
    menuItemClick(item, index) {
      this.activeIndex = index;
      this.$emit("change", item, index);
    },
    next() {
      if (this.data.length === 0) return;
      let index = (this.activeIndex + 1) % this.data.length;
      this.menuItemClick(this.data[index], index);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.cmp-menu {
  // background: linear-gradient(#ecf5fb 50%, #ffffff);
  background: #ecf5fb;
  // background: linear-gradient(270deg, #ffffff 0%, #ecf5fb 100%);
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  border-bottom: 1px solid #fff;
  .menu_list {
    font-size: 24px;
    color: #fff;
    display: flex;
    align-items: center;
    position: relative;
    text-align: center;
    cursor: pointer;
    > p {
      width: 80px;
      font-size: 20px;
      font-family: SourceHanSansCN-Light, SourceHanSansCN;
      font-weight: 300;
      color: #666666;
      padding: 13px 0;
      line-height: 30px;
      margin: 0 25px;
    }
    .bg {
      font-size: 20px;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      font-weight: 500;
      color: #333333;
      position: relative;
      &::after {
        content: "";
        position: absolute;
        width: 100%;
        height: 1px;
        background: #19a4ff;
        box-shadow: 0px 3px 9px 0px rgba(183, 183, 183, 0.27);
        left: 0;
        bottom: 0;
      }
    }
  }
}
</style>
